import React from 'react'
import {useNavigate} from 'react-router-dom';
import logo from '../images/LOGO_TRANSPARENT.png'
import{useState,useEffect} from 'react';
import { ethers } from 'ethers';
import cuteSloth from '../images/cute_sloth.webp'
import GooeyButton from './GooeyButton';
import { useMediaQuery } from 'react-responsive'
import hamburg from '../images/hamburg.png'
import './Nav.scss'
const Nav = () => {
    let provider;
 if(window.ethereum) {
     provider = new ethers.providers.Web3Provider(window.ethereum,"any")
     
 }
 const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })

 
  const[address,setAddress] = useState(null);
  async function connectWallet(){

    await provider.send("eth_requestAccounts", []);
 
  }

  if(window.ethereum){
    window.ethereum.on('accountsChanged', function (accounts) {
      setAddress(accounts[0])
      })

  }
    
  useEffect(()=>{
    if(window.ethereum){

      async function checkIfConnected(){
        const address = await provider.listAccounts();
        if(address.length>0){
          setAddress(address[0])
        }
      }
      checkIfConnected()
    }
    
  },[])

    let navigate = useNavigate();

 if(!isTabletOrMobile){
  return (
    <div class=' py-6     bg-black text-white  w-screen grid grid-cols-3 sticky z-10  top-0'>
        <div class='pl-4  pt-4'>
            <img onClick={()=>navigate('/')} src={logo} class=' fixed h-16  top-0 cursor-pointer'></img>
        </div>

        <div>
            <ul class='flex flex-row gap-8 '>
  
                <li onClick={()=>navigate('/dao')} class='m-auto cursor-pointer border-b-2 border-b-transparent hover:text-slate-500 hover:border-b-2 duration-500'>DAO</li>
                <li onClick={()=>navigate('/keys')} class='m-auto cursor-pointer border-b-2 border-b-transparent hover:text-slate-500 hover:border-b-2 duration-500'> Keys</li>
                <li onClick={()=>navigate('/recruit')} class='m-auto cursor-pointer border-b-2 border-b-transparent hover:text-slate-500 hover:border-b-2 duration-500'>Recruit A Friend</li>
                <li onClick={()=>{navigate('/claim')}} class='m-auto cursor-pointer border-b-2 border-b-transparent hover:text-slate-500 hover:border-b-2 duration-500'>Claim</li>
                <li onClick={()=>{navigate('/buy')}} class='m-auto cursor-pointer border-b-2 border-b-transparent hover:text-slate-500 hover:border-b-2 duration-500'>Buy</li>


                <li onClick={()=>{navigate('/burn')}} class='m-auto cursor-pointer border-b-2 border-b-transparent hover:text-slate-500 hover:border-b-2 duration-500'>Burn</li>


            </ul>
        </div>

        <div class='m-auto'>
           {/* {!address &&  <button   onClick={()=>connectWallet()} class='bg-slate-600 px-6 py-1 rounded-full hover:bg-slate-700 duration-150' >Connect</button>} */}
           {!address && <GooeyButton  connectWallet={connectWallet} text={"Connect"}/>}
            {/* {address && <button class='bg-slate-600 px-6 py-1 rounded-full hover:bg-slate-700 duration-150' > {address.slice(0,4) + '...' + address.slice(address.length-3,address.length) }</button>} */}
            {address && <GooeyButton text={address.slice(0,4) + '...' + address.slice(address.length-3,address.length)}/>}

         </div>
        

    </div>
  )
 }

 if(isTabletOrMobile){
   return(
     <MobileNav/>
   )
 }
}

export default Nav



const MobileNavDropdown =  (props) =>{
  let navigate = useNavigate();
  const {navOpen,setNavOpen} = props
 


  return(
    <>
    <div class={`flex flex-col items-center  top-0 bottom-0  h-[100%]  gap-y-8    w-[50vw] bg-black fixed transition-all slide-in`}>
      <button onClick={()=>{setNavOpen(false)}} class='inline-block  hover:text-slate-600 duration-150 mt-8 ml-[45%] select-none'>X</button>
        <div class='mt-[30%] gap-y-8 flex flex-col'>
        <div onClick={()=>{setNavOpen(false); navigate('/dao');}} class='cursor-pointer hover:text-slate-600 duration-150  select-none'>DAO</div>
        <div onClick={()=>{setNavOpen(false); navigate('/keys')}} class='cursor-pointer hover:text-slate-600 duration-150  select-none'>Keys</div>

        <div onClick={()=>{setNavOpen(false); navigate('/burn')}} class='cursor-pointer hover:text-slate-600 duration-150  select-none '>Burn</div>

        <div onClick={()=>{setNavOpen(false); navigate('/recruit')}} class='cursor-pointer hover:text-slate-600 duration-150  select-none'>Recruit</div>
        <div onClick={()=>{setNavOpen(false); navigate('/claim')}} class='cursor-pointer hover:text-slate-600 duration-150  select-none'>Claim</div>
        <div onClick={()=>{setNavOpen(false); navigate('/buy')}} class='cursor-pointer hover:text-slate-600 duration-150  select-none'>Buy</div>

        <div onClick={()=>{}} class='cursor-pointer hover:text-slate-600 duration-150  select-none '>Coming Soon</div>
        </div>

    </div>
    </>
  )
}
const MobileNav = () =>{
  const[navOpen,setNavOpen] = useState(false);
  let navigate = useNavigate();

  let provider;
  if(window.ethereum) {
    provider = new ethers.providers.Web3Provider(window.ethereum,"any")
    
}
  const[address,setAddress] = useState(null);
  async function connectWallet(){

    await provider.send("eth_requestAccounts", []);
 
  }

  if(window.ethereum){
    window.ethereum.on('accountsChanged', function (accounts) {
      setAddress(accounts[0])
      })

  }
    
  useEffect(()=>{
    if(window.ethereum){

      async function checkIfConnected(){
        const address = await provider.listAccounts();
        if(address.length>0){
          setAddress(address[0])
        }
      }
      checkIfConnected()
    }
  },[])

  return(
    <div class=' py-6     bg-black text-white  w-screen grid grid-cols-3 sticky z-10  top-0 '>
    <div class='pl-4  pt-4'>
        <img onClick={()=>navigate('/')} src={logo} class=' fixed h-16  top-3 cursor-pointer select-none'></img>
    </div>

 

  <div class='flex justify-center'>
   {!address && <button onClick={()=>connectWallet()} class='bg-indigo-400   px-4 py-2 rounded-md hover:bg-indigo-700  duration-150'>Connect</button>}
   {address && <button  class='bg-indigo-400   px-4 py-2 rounded-md hover:bg-indigo-700  duration-150'>{'Connected'}</button>}
  </div>
    <div class='m-auto'>
       <img  onClick={()=>setNavOpen(!navOpen)} class='h-10 cursor-pointer' src={hamburg}></img>
       
       
     </div>
     
     {navOpen &&  <MobileNavDropdown navOpen={navOpen} setNavOpen={setNavOpen} ></MobileNavDropdown> }
    

</div>

   )
  
}